import React from 'react';
import { motion } from 'framer-motion';
import { Badge } from '../../ui/badge';
import { Network, Cpu, Shield } from 'lucide-react';

const TitleSlide = ({ data }) => {
  return (
    <div className="w-full max-w-6xl mx-auto text-center relative">
      {/* Decorative elements */}
      <div className="absolute -top-20 -left-20 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-teal-500/10 rounded-full blur-3xl" />
      
      {/* Badge */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <Badge className="bg-gradient-to-r from-cyan-500/20 to-teal-500/20 text-cyan-300 border-cyan-500/30 px-4 py-1.5 text-sm mb-8">
          {data.badge}
        </Badge>
      </motion.div>

      {/* Logo/Icons */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.3 }}
        className="flex items-center justify-center gap-4 mb-8"
      >
        <div className="p-4 bg-gradient-to-br from-cyan-500/20 to-cyan-600/20 rounded-2xl border border-cyan-500/20">
          <Network className="w-10 h-10 text-cyan-400" />
        </div>
        <div className="p-4 bg-gradient-to-br from-teal-500/20 to-teal-600/20 rounded-2xl border border-teal-500/20">
          <Cpu className="w-10 h-10 text-teal-400" />
        </div>
        <div className="p-4 bg-gradient-to-br from-emerald-500/20 to-emerald-600/20 rounded-2xl border border-emerald-500/20">
          <Shield className="w-10 h-10 text-emerald-400" />
        </div>
      </motion.div>

      {/* Title */}
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="text-6xl md:text-8xl font-bold mb-4"
      >
        <span className="bg-gradient-to-r from-cyan-400 via-teal-400 to-emerald-400 bg-clip-text text-transparent">
          {data.title}
        </span>
      </motion.h1>

      {/* Subtitle */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="text-xl md:text-2xl text-slate-400 mb-8"
      >
        {data.subtitle}
      </motion.p>

      {/* Tagline */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed"
      >
        {data.tagline}
      </motion.p>

      {/* Bottom decoration */}
      <motion.div
        initial={{ opacity: 0, scaleX: 0 }}
        animate={{ opacity: 1, scaleX: 1 }}
        transition={{ delay: 0.8 }}
        className="mt-12 h-1 w-48 mx-auto bg-gradient-to-r from-transparent via-cyan-500 to-transparent rounded-full"
      />
    </div>
  );
};

export default TitleSlide;
